import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Masculino from "../pages/Masculino";
import Feminino from "../pages/Feminino";
import Geral from "../pages/Geral";
import Dashboard from "../pages/Dashboard";
import GTM from "../components/GTM/gtm";
import Perfumes from "../pages/Perfumes";
import Pokemon from "../pages/Pokemon";
import Carros from "../pages/Carros";

export default function AppRouter() {
  return (
    <BrowserRouter>
    <GTM></GTM>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/moda" element={<Masculino />} />
        <Route path="/divas" element={<Feminino />} />
        <Route path="/promos" element={<Geral />} />
        <Route path="/Perfumes" element={<Perfumes />} />
        <Route path="/Pokemon" element={<Pokemon />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/carros" element={<Carros />} />
      </Routes>
    </BrowserRouter>
  );
}